var _style, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTorqueGraphicOnly(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      enableBackground: "new 0 0 396 323.7"
    },
    viewBox: "0 0 396 323.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st13,.st8{fill:none;stroke:#000;stroke-width:3;stroke-miterlimit:10}.st13{stroke-width:1.0368}.st14,.st15,.st16{fill:#fff;stroke:#000}.st14{stroke-linecap:round;stroke-linejoin:round}.st15,.st16{stroke-miterlimit:10}.st16{fill:none;stroke-linecap:round;stroke-linejoin:round}")), /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.01 167.62h361.98v87.93H16.01z",
    style: {
      fill: "#e6e7e8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.01 79.06h361.98v87.93H16.01z",
    style: {
      fill: "#bcbec0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Layer_3_copy",
    d: "M153.4 78.94h86.75v176.61H153.4z",
    style: {
      fill: "#808285",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    x1: 161.769,
    x2: 232.231,
    y1: 176.806,
    y2: 176.806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#414042"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.273,
    style: {
      stopColor: "#939598"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#f1f2f2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.763,
    style: {
      stopColor: "#808285"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    style: {
      stopColor: "#414042"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M161.77 257.18V96.43h70.46v160.75h-70.46",
    style: {
      fill: "url(#SVGID_1_)",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Horizonal_lines"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.01 78.05h361.98M16.01 167.62h361.98M16.01 255.54h361.98",
    className: "st8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_7"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000063603777227424604140000007415451430690402447_",
    x1: 161.57,
    x2: 232.821,
    y1: 58.776,
    y2: 58.776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.001,
    style: {
      stopColor: "#939598"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.256,
    style: {
      stopColor: "#e6e7e8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.763,
    style: {
      stopColor: "#e6e7e8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#939598"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m225.11 21.37 7.71 6.07-6.82 7.33 6.32 6.13-7.1 6.3 7.1 6.64-6.9 7.33 6.9 6.55-7.24 6.46 6.97 6.69-6.83 6.96 6.38 8.35h-37.19 2.4-34.33l6.3-8.35-6.83-6.96 6.96-6.69-7.23-6.46 7.1-7.46-7.1-6.42 7.1-6.64-7.1-6.3 6.87-6.55.03-.04-7.01-6.3 7.1-6.64z",
    style: {
      fill: "url(#SVGID_00000063603777227424604140000007415451430690402447_)",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m226.07 34.94-63.83 6.05M232.12 40.91l-63.98 6.16M225.22 47.2l-63.2 6.72M231.41 53.92l-63.2 6.19M225.42 61.17l-63.74 6.64M225.11 21.37l-63.2 6.71M232.55 27.49l-63.97 6.82M232.32 67.54l-63.74 6.65",
    className: "st13"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M74.53 127.74h0",
    className: "st14"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1 142.69v-14.95H63.96v14.95H48.67v.23l25.86 22.4 25.86-22.4v-.23z",
    className: "st15"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M74.53 207.49h0",
    className: "st14"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1 192.55v14.94H63.96v-14.94H48.67v-.23l25.86-22.41 25.86 22.41v.23z",
    className: "st15"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M314.36 127.74h0",
    className: "st14"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M324.93 142.69v-14.95h-21.15v14.95h-15.29v.23l25.87 22.4 25.86-22.4v-.23z",
    className: "st15"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M314.36 207.49h0",
    className: "st14"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M324.93 192.55v14.94h-21.15v-14.94h-15.29v-.23l25.87-22.41 25.86 22.41v.23z",
    className: "st15"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M196.42 215.23h0",
    className: "st14"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M205.83 230.18v-14.95h-18.82v14.95H173.4v.23l23.02 22.4 23.02-22.4v-.23z",
    className: "st15"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M196.42 136.63h0",
    className: "st14"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M187.01 121.68v14.95h18.82v-14.95h13.61v-.23l-23.02-22.4-23.02 22.4v.23z",
    className: "st15"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M167.59 152.58v8.29M225.97 152.58v8.29",
    className: "st16"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M167.59 156.72h58.07",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "4,4"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000000938641044556596750000003745736296398368446_",
    x1: 161.769,
    x2: 232.41,
    y1: 78.22,
    y2: 78.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.256,
    style: {
      stopColor: "#6d6e71"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.525,
    style: {
      stopColor: "#bcbec0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.763,
    style: {
      stopColor: "#6d6e71"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m168.87 60.26-7.1 7.46 7.24 6.46-6.97 6.69 6.83 6.96-6.3 8.35h34.34-2.4 37.18l-6.38-8.35 6.83-6.96-6.97-6.69 7.24-6.46-7.31-7.37z",
    style: {
      fill: "url(#SVGID_00000000938641044556596750000003745736296398368446_)",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m226.27 74.93-63.83 6.05M232.25 80.87l-63.52 7.08M225.42 87.83l-62.61 7.77",
    className: "st13"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Hex_Nut_copy"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000170971547428844994780000005371470416368454329_",
    x1: 198.519,
    x2: 198.519,
    y1: 58.909,
    y2: 32.865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    style: {
      stopColor: "#414042"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757,
    style: {
      stopColor: "#434345"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.821,
    style: {
      stopColor: "#4b4b4d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.874,
    style: {
      stopColor: "#58585a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    style: {
      stopColor: "#68696c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.961,
    style: {
      stopColor: "#7c7e80"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#939598"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M157.43 31.4h79.34l13.19 5.69v6.9H147.08v-9.05s5.22-3.54 10.35-3.54z",
    style: {
      fill: "url(#SVGID_00000170971547428844994780000005371470416368454329_)",
      stroke: "#000",
      strokeWidth: 1.0513,
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000107581046376197127080000005167217319477384095_",
    x1: 135.722,
    x2: 169.733,
    y1: 53.959,
    y2: 53.959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#58595b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#f1f2f2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    style: {
      stopColor: "#6d6e71"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M169.73 39.29s-5.91-7.07-9.91-7.68c-2.22-.34-3.85-.22-5.57-.02-3.6.41-18.45 10.48-18.45 10.48l-.09 34.45h34.01V39.29z",
    style: {
      fill: "url(#SVGID_00000107581046376197127080000005167217319477384095_)",
      stroke: "#000",
      strokeWidth: 1.0513,
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000066498028642221118050000014461341724005414317_",
    x1: 1658.789,
    x2: 1692.8,
    y1: 53.959,
    y2: 53.959,
    gradientTransform: "matrix(-1 0 0 1 1916.525 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#58595b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#f1f2f2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    style: {
      stopColor: "#6d6e71"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M223.72 39.29s5.91-7.07 9.91-7.68c2.22-.34 3.85-.22 5.57-.02 3.6.41 18.45 10.48 18.45 10.48l.09 34.45h-34.01V39.29z",
    style: {
      fill: "url(#SVGID_00000066498028642221118050000014461341724005414317_)",
      stroke: "#000",
      strokeWidth: 1.0513,
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000067197904028131788180000016332055994031236493_",
    x1: 169.733,
    x2: 223.724,
    y1: 9.581,
    y2: 9.581,
    gradientTransform: "matrix(1 0 0 -1 0 63.551)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7c7e80"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#f1f2f2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    style: {
      stopColor: "#6d6e71"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M169.73 76.52h53.99V39.29s-5.19-7.71-12.47-7.71c-12.1 0-16.94-.18-27.27-.18-8.15 0-14.15 7.89-14.15 7.89h-.1v37.25",
    style: {
      fill: "url(#SVGID_00000067197904028131788180000016332055994031236493_)",
      stroke: "#000",
      strokeWidth: 1.0513,
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000176016761570148951970000016662621353192613046_",
    x1: 1636.351,
    x2: 1636.351,
    y1: 458.073,
    y2: 432.029,
    gradientTransform: "rotate(180 915.645 366.443)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    style: {
      stopColor: "#414042"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757,
    style: {
      stopColor: "#434345"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.821,
    style: {
      stopColor: "#4b4b4d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.874,
    style: {
      stopColor: "#58585a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    style: {
      stopColor: "#68696c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.961,
    style: {
      stopColor: "#7c7e80"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#939598"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M236.03 302.33h-79.34l-13.19-5.69v-6.9h102.87v9.05c.01-.01-5.21 3.54-10.34 3.54z",
    style: {
      fill: "url(#SVGID_00000176016761570148951970000016662621353192613046_)",
      stroke: "#000",
      strokeWidth: 1.0513,
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000092441794369226846300000001578787527376866477_",
    x1: 1573.554,
    x2: 1607.566,
    y1: 453.123,
    y2: 453.123,
    gradientTransform: "rotate(180 915.645 366.443)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#58595b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#f1f2f2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    style: {
      stopColor: "#6d6e71"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M223.72 294.43s5.91 7.07 9.91 7.68c2.22.34 3.85.22 5.57.02 3.6-.41 18.45-10.48 18.45-10.48l.09-34.45h-34.01V294.43z",
    style: {
      fill: "url(#SVGID_00000092441794369226846300000001578787527376866477_)",
      stroke: "#000",
      strokeWidth: 1.0513,
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000156560771056666259040000016704885141007231387_",
    x1: 220.956,
    x2: 254.968,
    y1: 453.123,
    y2: 453.123,
    gradientTransform: "matrix(1 0 0 -1 -85.235 732.887)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#58595b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#f1f2f2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    style: {
      stopColor: "#6d6e71"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M169.73 294.43s-5.91 7.07-9.91 7.68c-2.22.34-3.85.22-5.57.02-3.6-.41-18.45-10.48-18.45-10.48l-.09-34.45h34.01v.52l.01 36.71z",
    style: {
      fill: "url(#SVGID_00000156560771056666259040000016704885141007231387_)",
      stroke: "#000",
      strokeWidth: 1.0513,
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000111894463778017060520000011694458167006194838_",
    x1: 1607.566,
    x2: 1661.557,
    y1: -389.583,
    y2: -389.583,
    gradientTransform: "matrix(-1 0 0 1 1831.29 669.336)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7c7e80"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#f1f2f2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    style: {
      stopColor: "#6d6e71"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M223.72 257.2h-53.99v37.23s5.19 7.71 12.47 7.71c12.1 0 16.94.18 27.27.18 8.15 0 14.15-7.89 14.15-7.89h.1v-37.25",
    style: {
      fill: "url(#SVGID_00000111894463778017060520000011694458167006194838_)",
      stroke: "#000",
      strokeWidth: 1.0513,
      strokeMiterlimit: 10
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTorqueGraphicOnly);
export default __webpack_public_path__ + "static/media/Torque_Graphic_Only.81d3f427b7d2ce1c6476f5cd6a347067.svg";
export { ForwardRef as ReactComponent };